import { render, staticRenderFns } from "./CoozzyHeaderTransparent.vue?vue&type=template&id=3051bdab&scoped=true"
import script from "./CoozzyHeaderTransparent.vue?vue&type=script&lang=js"
export * from "./CoozzyHeaderTransparent.vue?vue&type=script&lang=js"
import style0 from "./CoozzyHeaderTransparent.vue?vue&type=style&index=0&id=3051bdab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051bdab",
  null
  
)

export default component.exports